// extracted by mini-css-extract-plugin
module.exports = {"cpNotice":"_2MDaL","cpCon":"dPyIj","title":"_2ljvl","close":"duvly","cpIntro":"_3iPRF","messengerImg":"_1Vu6g","arrowImg":"_1cDOn","entryImg":"_3p-Eb"};